module.exports = __webpack_public_path__ + "static/media/fontello.b3e5d987.svg";